module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p_toc_heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0002#auto_bookmark_toc_1"
    }
  }, [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0003#auto_bookmark_toc_1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0004#auto_bookmark_toc_1"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0005#auto_bookmark_toc_1"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0006#auto_bookmark_toc_1"
    }
  }, [_vm._v("Daddies")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('a', {
    attrs: {
      "href": "#/OPS/section0007#auto_bookmark_toc_1"
    }
  }, [_vm._v("Baby Steps from Home")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0008#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wingman")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0009#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Your Feet Touch the Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0010#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dark Alley")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0011#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under the Yellow Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0012#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kept in Cages")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0013#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0014#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making It Through")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0015#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Songs from Outer Space")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0016#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May to November")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0017#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous Hobbies")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0018#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footsteps in the Sand")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0019#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The View from Mars")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0020#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dancing Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0021#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frayed and Broken")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0022#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken Hearts and Broken Strings")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0023#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Your Head is in the Stars, You’re Everywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0024#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reckoning")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0025#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giving Thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0026#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amy’s Dark Contemporary Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0027#auto_bookmark_toc_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Readers love Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0028#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0029#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Amy Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "p_toc_entry_"
  }, [_c('span', {
    attrs: {
      "href": "#/OPS/section0031#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ef6232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0001.vue
// module id = 57
// module chunks = 0